module.exports = __webpack_public_path__ + "static/media/export.aa388a48.png";